import $ from 'jquery';

/**
 * Reduced footer terms read more / read less (OFL-15993).
 * Uses CSS max-height transitions so open/close stays smooth
 * (avoids jQuery animate + display:none fighting each other).
 */
export default class FooterTerms {
    static OPEN_MS = 400;
    static CLOSE_MS = 400;
    isAnimating = false;
    init() {
        $(document).ready(() => {
            this.setup();
        });
    }

    setup() {
        const $content = $('#footer-terms-panel');
        const $button = $('#footer-terms-toggle');
        if (!$content.length || !$button.length) {
            return;
        }

        const content = $content[0];

        // Own toggle — avoid Foundation fighting our transition timing
        $content.removeAttr('data-toggler');
        $button.removeAttr('data-toggle');
        $button.removeAttr('data-toggler');

        $button.removeClass('show');
        this.setExpandedState($button, false);

        $content.on('transitionend', (event) => {
            if (event.target !== content || event.originalEvent.propertyName !== 'max-height') {
                return;
            }


            if ($content.hasClass('is-expanded')) {
                $content.css('max-height', 'none');
            } else {
                $content.addClass('collapsed');
                $content.css('max-height', '');
            }
        });

        $button.on('click', () => {
            if ($content.hasClass('is-expanded')) {
                this.collapse($content, $button);
            } else {
                this.expand($content, $button);
            }
        });
    }

    expand($content, $button) {
        const content = $content[0];
        const button = $button[0];
        this.setExpandedState($button, true);
        const initialButtonTop = button.getBoundingClientRect().top;

        const startHeight = content.scrollHeight;
        $content.css({
            transition: 'none',
            maxHeight: startHeight + 'px'
        });

        $content.removeClass('collapsed').addClass('is-expanded');
        const endHeight = content.scrollHeight;

        // Force reflow so the browser registers the starting max-height
        void content.offsetHeight;

        $content.css({
            transition: `max-height ${FooterTerms.OPEN_MS}ms linear`,
            maxHeight: endHeight + 'px'
        });
        this.syncScroll($button, initialButtonTop, FooterTerms.OPEN_MS);
    }

    collapse($content, $button) {
        const content = $content[0];
        const button = $button[0];
        this.setExpandedState($button, false);
        const initialButtonTop = button.getBoundingClientRect().top;

        const startHeight = content.scrollHeight;
        $content.css({
            transition: 'none',
            maxHeight: startHeight + 'px'
        });

        // Measure collapsed preview height without flashing layout
        $content.removeClass('is-expanded').addClass('collapsed');
        const endHeight = content.scrollHeight;
        $content.removeClass('collapsed');

        void content.offsetHeight;

        $content.css({
            transition: `max-height ${FooterTerms.CLOSE_MS}ms linear`,
            maxHeight: endHeight + 'px'
        });
        this.syncScroll($button, initialButtonTop, FooterTerms.CLOSE_MS);
    }

    syncScroll($button, initialButtonTop, duration) {
        const button = $button[0];
        const startTime = performance.now();

        const tick = (time) => {
            const elapsed = time - startTime;

            const currentButtonTop = button.getBoundingClientRect().top;
            const delta = currentButtonTop - initialButtonTop;

            if (Math.abs(delta) > 0.1) {
                window.scrollBy(0, delta);
            }

            if (elapsed < duration) {
                requestAnimationFrame(tick);
            }
        };

        requestAnimationFrame(tick);
    }

    setExpandedState($button, isExpanded) {
        $button
            .toggleClass('show', isExpanded)
            .attr('aria-expanded', isExpanded ? 'true' : 'false')
            .find('.footer-terms-toggle-label')
            .text(isExpanded ? $button.attr('data-less') : $button.attr('data-more'));
    }
}
